import styled from "@emotion/styled";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { PageWithFixedBottom } from "../../components/Templates/PageWithFixedBottom";
import { CollapsibleInvestmentProposal } from "../../components/Templates/UserDetail/ProposalMesage/CollapsibleInvestmentProposal";
import { BULK_MAX_TARGET_USER_COUNT } from "../../constants/BulkProposal";
import { useBulkConditionTarget } from "../../hooks/users/useBulkConditionTarget";
import { SearchFormTypeForUserListState } from "../../view_models/atoms";

const StyledAccordion = styled(Accordion)`
  &.Mui-expanded {
    margin-top: 0;
  }
`;
const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0 2rem;
  background-color: #f5f5f5;
  height: 40px;
  min-height: 40px;
  font-weight: bold;
  &.Mui-expanded {
    min-height: 40px;
  }
`;

const InvestmentProposalBulkRegister: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userIdsString = queryParams.get("userIds");

  const userIds = userIdsString ? userIdsString.split(",").map((userId) => Number(userId)) : [];

  const searchForm = useRecoilValue(SearchFormTypeForUserListState);
  const { isConditionMode, status, search, totalCount, summaryParts } = useBulkConditionTarget({
    searchForm,
    isReProposal: false,
    listPath: "/users",
  });

  // 条件が復元できない / 件数が取れない場合はフックが一覧へ戻すため、ここでは何も描画しない
  if (isConditionMode && status !== "ready") {
    return null;
  }

  if (isConditionMode && search) {
    return (
      <PageWithFixedBottom
        bottomContent={
          <CollapsibleInvestmentProposal conditionTarget={{ search, totalCount }} />
        }
        bottomPadding="80px"
      >
        <StyledAccordion defaultExpanded={true}>
          <StyledAccordionSummary aria-controls={"proposal-input"} sx={{ height: 80, p: 0 }}>
            一括投資提案 絞り込み条件
          </StyledAccordionSummary>
          <AccordionDetails sx={{ p: 0 }}>
            <Box sx={{ mt: "10px", mr: "22px", mb: "25px", ml: "40px" }}>
              {/* 想定より多い対象に送ってしまわないよう、総件数を必ず出す */}
              <Typography variant={"h6"} sx={{ mb: 1 }}>
                対象: {totalCount}名
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {summaryParts.length > 0 ? summaryParts.join(" / ") : "条件なし"}
              </Typography>
              {totalCount === 0 && (
                <Typography variant="body2" color="warning.main" sx={{ mt: 1 }}>
                  条件に一致する提案対象のユーザーがいません。
                  <br />
                  一覧で条件を指定し直してください。
                </Typography>
              )}
              {totalCount > BULK_MAX_TARGET_USER_COUNT && (
                <Typography variant="body2" color="warning.main" sx={{ mt: 1 }}>
                  対象が上限の{BULK_MAX_TARGET_USER_COUNT.toLocaleString()}名を超えているため送信できません。
                  <br />
                  一覧で条件を追加して対象を絞ってください。
                </Typography>
              )}
            </Box>
          </AccordionDetails>
        </StyledAccordion>
      </PageWithFixedBottom>
    );
  }

  return (
    <PageWithFixedBottom
      bottomContent={<CollapsibleInvestmentProposal userIds={userIds} />}
      bottomPadding="80px"
    >
      <StyledAccordion defaultExpanded={true}>
        <StyledAccordionSummary aria-controls={"proposal-input"} sx={{ height: 80, p: 0 }}>
          一括投資提案 選択中ユーザID
        </StyledAccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          <Box sx={{ mt: "10px", mr: "22px", mb: "25px", ml: "40px" }}>
            <Typography variant={"h6"} sx={{ mb: 1 }}>
              対象: {userIds.length}名
            </Typography>
            {userIds.map((userId) => (
              <Typography key={userId} variant={"h6"}>
                ID: {userId}
              </Typography>
            ))}
          </Box>
        </AccordionDetails>
      </StyledAccordion>
    </PageWithFixedBottom>
  );
};

export default InvestmentProposalBulkRegister;
